/**
 * Client variant identifiers, mirroring the App\Enums\EdverumClient PHP enum.
 *
 * Drives which dashboard variant (and any future per-client behavior) is rendered.
 * The active value is exposed to the frontend via window.__INITIAL_STATE__.EnvironmentSettings.client.
 */
export const EDVERUM_CLIENTS = Object.freeze({
    STANBRIDGE: 'stanbridge',
    CORPORATE: 'corporate',
});

export const DEFAULT_EDVERUM_CLIENT = EDVERUM_CLIENTS.STANBRIDGE;
